import { render, staticRenderFns } from "./unknown-words.vue?vue&type=template&id=78a36822&"
import script from "./unknown-words.vue?vue&type=script&lang=js&"
export * from "./unknown-words.vue?vue&type=script&lang=js&"
import style0 from "./unknown-words.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable})
